import { createSlice } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

const initialState: TDefaultStoreDTO = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: 'createdAt',
	searchValue: '',
};

const assetsRentIncomingRequests = createSlice({
	name: 'assetsRentIncomingRequests',
	initialState,
	reducers: {
		...defaultStoreDTO,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
} = assetsRentIncomingRequests.actions;

export default assetsRentIncomingRequests.reducer;
